export const companySizes = [
  '1-500',
  '501-1,000',
  '1,001-2,500',
  '2,501-5,000',
  '5,001-7,500',
  '7,501-10,000',
  '10,000+',
];
